// Global Welcome Message Manager
// This ensures welcome messages continue rotating even when user navigates away from homepage

class WelcomeMessageManager {
    constructor() {
      this.welcomeMessages = [
        "Every role you unlock gets you closer to your dream team",
        "Pre-Onboarding is free — try it now and see qualified talent instantly",
        "You've got credits waiting. Why not use one before it expires?",
        "Studios worldwide are scaling today. Don't let your project fall behind",
        "Your next hire could change everything. Ready to discover them?"
      ];
      
      this.currentIndex = this.getStoredIndex();
      this.intervalId = null;
      this.listeners = new Set();
      
      this.start();
    }
  
    getStoredIndex() {
      const saved = localStorage.getItem('exodia-welcome-message-index');
      return saved ? parseInt(saved, 10) : 0;
    }
  
    getStoredMessage() {
      const saved = localStorage.getItem('exodia-welcome-message');
      return saved || "Welcome back, Guest User - let's build your team today!";
    }
  
    getStoredLastUpdate() {
      const saved = localStorage.getItem('exodia-welcome-last-update');
      return saved ? parseInt(saved, 10) : 0;
    }
  
    getCurrentMessage() {
      return this.getStoredMessage();
    }
  
    getCurrentIndex() {
      return this.getStoredIndex();
    }
  
    updateMessage() {
      const lastUpdate = this.getStoredLastUpdate();
      const now = Date.now();
      const threeMinutes = 3 * 60 * 1000; // 3 minutes in milliseconds
      
      if (now - lastUpdate >= threeMinutes) {
        this.currentIndex = (this.currentIndex + 1) % this.welcomeMessages.length;
        const newMessage = this.welcomeMessages[this.currentIndex];
        
        // Save to localStorage
        localStorage.setItem('exodia-welcome-message-index', this.currentIndex.toString());
        localStorage.setItem('exodia-welcome-message', newMessage);
        localStorage.setItem('exodia-welcome-last-update', now.toString());
        
        // Notify all listeners
        this.listeners.forEach(listener => listener(newMessage, this.currentIndex));
        
        return true; // Message was updated
      }
      
      return false; // No update needed
    }
  
    start() {
      // Check immediately
      this.updateMessage();
      
      // Set up interval to check every minute
      this.intervalId = setInterval(() => {
        this.updateMessage();
      }, 60000); // Check every minute
    }
  
    stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  
    subscribe(listener) {
      this.listeners.add(listener);
      
      // Return unsubscribe function
      return () => {
        this.listeners.delete(listener);
      };
    }
  
    // Force update message (for testing or manual refresh)
    forceUpdate() {
      this.currentIndex = (this.currentIndex + 1) % this.welcomeMessages.length;
      const newMessage = this.welcomeMessages[this.currentIndex];
      
      localStorage.setItem('exodia-welcome-message-index', this.currentIndex.toString());
      localStorage.setItem('exodia-welcome-message', newMessage);
      localStorage.setItem('exodia-welcome-last-update', Date.now().toString());
      
      this.listeners.forEach(listener => listener(newMessage, this.currentIndex));
    }
  
    // Debug function to check current state
    getDebugInfo() {
      return {
        currentIndex: this.currentIndex,
        currentMessage: this.getCurrentMessage(),
        lastUpdate: this.getStoredLastUpdate(),
        timeSinceLastUpdate: Date.now() - this.getStoredLastUpdate(),
        listenersCount: this.listeners.size,
        isRunning: this.intervalId !== null
      };
    }
  }
  
  // Create singleton instance
  const welcomeMessageManager = new WelcomeMessageManager();
  
  export default welcomeMessageManager;
  